module.exports = __webpack_public_path__ + "img/ani-2.f958cda8.png";